import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

import Button from "../Button/Button";
import Link from "../Link";

export default function ArticleTags() {
  const route = useRouteResponse("articlePage");
  const tags = route.article?.tags || [];

  if (!tags.length) return null;

  return (
    <div
      className="flex w-full flex-wrap gap-3 px-3 py-4"
      data-testid="thinkchina-tags"
    >
      {tags.map((tag) => (
        <Link key={tag.name} to={tag.urlPath} data-testid={`tag-${tag.name}`}>
          <Button variant="tertiary" size="medium">
            {tag.name}
          </Button>
        </Link>
      ))}
    </div>
  );
}
